/**
 * Work clock / time log constants (M6).
 * Mirror backend constants/timeLog.js — keys and display labels only.
 */

export const TIME_LOG_ACTION = Object.freeze({
  IN: 'in',
  PAUSE: 'pause',
  RESUME: 'resume',
  OUT: 'out',
});

export const TIME_LOG_STATE = Object.freeze({
  OFF: 'off',
  ACTIVE: 'active',
  PAUSED: 'paused',
});

export const TIME_LOG_SOURCE = Object.freeze({
  WEB: 'web',
  MOBILE: 'mobile',
});

export const TIME_LOG_ACTION_LABEL = Object.freeze({
  [TIME_LOG_ACTION.IN]: 'Clock In',
  [TIME_LOG_ACTION.PAUSE]: 'Paused',
  [TIME_LOG_ACTION.RESUME]: 'Resumed',
  [TIME_LOG_ACTION.OUT]: 'Clock Out',
});

export const TIME_LOG_STATE_LABEL = Object.freeze({
  [TIME_LOG_STATE.OFF]: 'Off shift',
  [TIME_LOG_STATE.ACTIVE]: 'On shift',
  [TIME_LOG_STATE.PAUSED]: 'Paused',
});

export const DEFAULT_TIME_LOG_SOURCE = TIME_LOG_SOURCE.WEB;
